var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { ProjectDetailsPopoverDocument } from './query.gql';
import { useUsers } from '../useUsers';
const isValidUser = (userAcl) => { var _a; return Boolean((_a = userAcl.user) === null || _a === void 0 ? void 0 : _a.id); };
const isValidTeam = (teamAcl) => { var _a; return Boolean((_a = teamAcl.team) === null || _a === void 0 ? void 0 : _a.id); };
export const useProject = (id) => {
    const _a = useQuery(ProjectDetailsPopoverDocument, {
        variables: { id },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const project = (data === null || data === void 0 ? void 0 : data.fileSystemProject) || null;
    const members = {
        users: (project === null || project === void 0 ? void 0 : project.acls.filter(isValidUser).map((acl) => {
            var _a;
            return ({
                id: acl.user.id,
                name: (_a = acl.user.name) !== null && _a !== void 0 ? _a : '',
            });
        })) || [],
        teams: (project === null || project === void 0 ? void 0 : project.acls.filter(isValidTeam).map((acl) => ({
            id: acl.team.id,
            name: acl.team.name,
        }))) || [],
    };
    const metadata = (project === null || project === void 0 ? void 0 : project.metadata) || [];
    const projectOwnerUserIds = metadata
        .filter((m) => m.property.name === 'ProjectOwner')
        .flatMap((m) => m.value);
    const _b = useUsers(projectOwnerUserIds), { users: projectOwners } = _b, projectOwnersRest = __rest(_b, ["users"]);
    return Object.assign(Object.assign(Object.assign({}, rest), projectOwnersRest), { project, members, projectOwners });
};
